import StoneBerryCredit from '@/components/customercenter-ui/icons/StoneBerryCredit2 copy';
import MasonCredit from '@/components/customercenter-ui/svgs/masonCredit';
import MasonEasyPay from '@/components/customercenter-ui/svgs/masonEasyPay';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/customercenter-ui/ui/card';
import { getCardIcon } from '@/components/customercenter-ui/utils/crediCardUtils';
import { maskPhoneNumber, maskPostalCode } from '@/components/customercenter-ui/utils/formatUtils';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';

const orderConfirmationPayment = ({ order, loggedIn, creditAccountNumber }: any) => {
  const divisionCode = order?.paymentDetails?.soaCustomer?.DivisionCustomers?.[0]?.divisionCode;

  const renderComponent = () => {
    switch (divisionCode) {
      case 'ZD':
        return <MasonEasyPay />;
      case 'ZB':
        return <StoneBerryCredit />;
      case 'ZY':
        return <MasonCredit />;
      default:
        return <StoneBerryCredit />;
    }
  };
  const paymentMethod = order?.paymentType?.toUpperCase();
  switch (paymentMethod) {
    case 'CARD':
      return (
        <section className="flex w-1/2 flex-col gap-8">
          <section className="flex flex-col gap-2">
            <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().paymentMethod}</p>
            <section className="gbomit">{getCardIcon(order?.paymentDetails?.creditCardType)}</section>
          </section>
          <section className="flex flex-col gap-1.5">
            <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().cardNumberText}</p>
            <p className="gbmask">{`**** ${order?.paymentDetails?.ccLast4Digits}`}</p>
          </section>
          <section className="flex flex-col gap-1.5">
            <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().expirationDate}</p>
            <p className="gbmask">
              {order?.paymentDetails?.expirationMonth}/{order?.paymentDetails?.expirationYear}
            </p>
          </section>
        </section>
      );
    case 'CREDIT':
      return (
        <section className="flex w-1/2 flex-col gap-10">
          <section className="mr-6 flex flex-col gap-2">
            <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().paymentMethod}</p>
            <div className="gbomit mr-4 flex w-[160px] items-start">{renderComponent()}</div>
          </section>
          {loggedIn && creditAccountNumber ? (
            <section className="flex flex-col gap-1.5">
              <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().accountNumber}</p>
              <p className="gbmask">{creditAccountNumber}</p>
            </section>
          ) : (
            <></>
          )}
        </section>
      );
    case 'CASH':
      return (
        <section className="flex w-1/2 flex-col gap-8">
          <section className="flex flex-col gap-2">
            <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().paymentMethod}</p>
            {order?.paymentDetails?.paymentMethod}
          </section>
          <section className="flex flex-col gap-1.5">
            <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().batchNumber}</p>
            <p className="gbmask">{order?.paymentDetails?.batchNumber}</p>
          </section>
          <section className="flex flex-col gap-1.5">
            <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().cashAmount}</p>
            <p>{order?.paymentDetails?.cashAmount}</p>
          </section>
        </section>
      );
    case 'CHECK':
      return (
        <section className="flex w-1/2 flex-col gap-8">
          <section className="flex flex-col gap-2">
            <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().paymentMethod}</p>
            {order?.paymentDetails?.paymentMethod}
          </section>
          <section className="flex flex-col gap-1.5">
            <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().batchNumber}</p>
            <p className="gbmask">{order?.paymentDetails?.batchNumber}</p>
          </section>
        </section>
      );
    case 'NOCHARGEORDER':
      return (
        <section className="flex w-1/2 flex-col gap-8">
          <section className="flex flex-col gap-2">
            <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().paymentMethod}</p>
            {mapLocaleToMeaningfulFormat().noChargeTitle}
          </section>
        </section>
      );
    default:
      return <div>{mapLocaleToMeaningfulFormat().invalidPayment}</div>;
  }
};

const OrderPayment = ({ order, account, loggedIn, creditAccountNumber }: any) => {
  return (
    <Card className="mb-5 w-full rounded-none border-t border-foggyGray p-2 md:mb-0 md:mt-4 md:rounded-md md:border md:shadow-lg">
      <CardHeader className="py-5 pl-6">
        <CardTitle className="flex flex-wrap">
          <p className="mr-auto text-22 font-bold">{mapLocaleToMeaningfulFormat(['capital']).payment}</p>
        </CardTitle>
      </CardHeader>
      <CardContent className="md:flex">
        {orderConfirmationPayment({ order, loggedIn, creditAccountNumber })}
        <section className="pt-8 md:pt-0">
          <p className="text-lg font-bold">{mapLocaleToMeaningfulFormat().billingAddress}</p>
          <p className="gbmask overflow-hidden text-ellipsis pt-2.5 text-base font-normal lg:pr-3">
            {order?.billingAddress?.firstName} {order?.billingAddress?.lastName} <br />
            {order?.billingAddress?.streetName} <br />
            {order?.billingAddress?.additionalAddressInfo ? (
              <>
                {order?.billingAddress?.additionalAddressInfo}
                <br />
              </>
            ) : (
              ''
            )}
            {order?.billingAddress?.city}, {order?.billingAddress?.state}{' '}
            {maskPostalCode(order?.billingAddress?.postalCode ?? '')}
          </p>
          <p className="gbmask pt-2.5">{maskPhoneNumber(order?.billingAddress?.phone)}</p>
          <section className="pt-6">
            <p className="mb-1.5 text-base font-bold">{mapLocaleToMeaningfulFormat().contactInfo}</p>
            <p className="gbmask">{order?.email ? order?.email : account?.email}</p>
          </section>
        </section>
      </CardContent>
    </Card>
  );
};

export default OrderPayment;
